module.exports = __webpack_public_path__ + "static/img/pc_01.9ba29ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c9/pc/pc_01.png
// module id = aSkS
// module chunks = 0